import React, { useRef, useState } from "react";

import { Link } from "gatsby";

import { Menu, Transition } from "@headlessui/react";

const Dropdown: React.FC<any> = ({
  name,
  subItems,
  useHover,
  className,
  menuClassName, // OVERRIDE DEFAULT CSS FOR DROPDOWN
  itemsClassName,
  children,
  size = "s",
  icon = true,
}) => {
  const [dropdownIconToggle, setDropdownIconToggle] = useState(false);
  const buttonRef = useRef<any>(null);
  const dropdownRef = useRef<any>(null);
  const timeoutDuration = 200;
  let timeout: any;

  const handleDropdownIconToggle = () => {
    setDropdownIconToggle(!dropdownIconToggle);
  };

  const openMenu = () => {
    buttonRef?.current.click();
    handleDropdownIconToggle();
  };

  const closeMenu = () => {
    handleDropdownIconToggle();

    dropdownRef?.current?.dispatchEvent(
      new KeyboardEvent("keydown", {
        key: "Escape",
        bubbles: true,
        cancelable: true,
      })
    );
  };

  const dropDownIcon = !dropdownIconToggle ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
      />
    </svg>
  );

  const onMouseEnter = (closed?: any) => {
    clearTimeout(timeout);
    closed && openMenu();
  };

  const onMouseLeave = (open: any) => {
    open && (timeout = setTimeout(() => closeMenu(), timeoutDuration));
  };

  return (
    <Menu as="div" className={`relative cursor-pointer ${className}`}>
      {({ open }) => (
        <>
          <span
            className="relative block"
            onClick={openMenu}
            onMouseEnter={() => useHover && onMouseEnter(!open)}
            onMouseLeave={() => useHover && onMouseLeave(open)}
          >
            <Menu.Button
              ref={buttonRef}
              className={`flex ${
                menuClassName
                  ? menuClassName
                  : "items-center gap-1 hover:text-primary-500"
              }`}
              as={"button"}
            >
              {/* PASS icon too as component if needed */}
              {name}
              {icon ? (
                <span>
                  {dropDownIcon}
                  {/* <img src={dropDownIcon} className="filter" alt="down" /> */}
                </span>
              ) : null}
            </Menu.Button>
          </span>

          <Transition show={open}>
            <Menu.Items
              ref={dropdownRef}
              onMouseEnter={() => useHover && onMouseEnter()}
              onMouseLeave={() => useHover && onMouseLeave(open)}
              static
              className={`${
                itemsClassName
                  ? itemsClassName
                  : "nav-dropdown-menu absolute right-0 mt-2 origin-top-right rounded-md border-t-2 border-primary-600 bg-white text-slate-500 shadow-lg ring-1 ring-black ring-opacity-5"
              } ${size === `m` ? "w-48" : size === `l` ? `w-60` : `w-36`}`}
            >
              <div className="py-1">
                {subItems.map((item: any) => (
                  <Menu.Item key={item.key}>
                    {({ active }) => (
                      <Link
                        to={item.url}
                        className={`block px-4 py-2 ${
                          active && "text-primary-600"
                        }`}
                      >
                        {item.name}
                      </Link>
                    )}
                  </Menu.Item>
                ))}
                {/* FOR ADDITIONAL DROPDOWN that requires new css, like Sign OUT */}
                {children}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default Dropdown;
